export const fadeIn = {
    pageInitial: {
        opacity: 0,
        filter: "blur(5px)",
    },
    pageAnimate: {
        opacity: 1,
        filter: "blur(0px)",
    },
    pageExit: {
        opacity: 0,
        filter: "blur(5px)",
    },
};
